import React, { useState } from "react";
import {
  TextField,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { errorToaster } from "../../../helper/toasterConfiguration";

export const FormAddMembershipGroup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [data, setData] = useState({
    name: "",
    description:"",
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    formDataToSend.append('name', data.name);
    formDataToSend.append('description', data.description);

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.MembershipGroup.Add,
        data: formDataToSend,
        isFormData: true,
        showErrors: ["name"],
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Membership-Groups");
      } 
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">

        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          required
          type="title"
          autoComplete="off"
          value={data.name}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          type="description"
          multiline
          rows={2}
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      {errorMessage && (
        <div className="w-full text-start text-red-600">*{errorMessage}</div>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit || errorMessage}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
